import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function () {
    const root = document.querySelector(
        '.o-estrategia__swiper[data-swiper="estrategia"]',
    );
    if (!root) return;

    const prevEl = root.querySelector(".o-estrategia__nav--prev");
    const nextEl = root.querySelector(".o-estrategia__nav--next");
    const paginationEl = root.querySelector(".o-estrategia__pagination");

    const slider = new Swiper(root, {
        modules: [Pagination, Navigation],
        slidesPerView: 1.15,
        spaceBetween: 8,
        centeredSlides: false,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        pagination: {
            el: paginationEl,
            type: "progressbar",
        },
        navigation: {
            prevEl,
            nextEl,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 5,
            },
        },
    });

    return slider;
}
